@if (item) {
  <mat-card class="card">
    <mat-card-header class="card-padding flex-row">
      <a routerLink="/charts/{{ item.uniqueName }}" target="_blank">
        <div style="flex: 0" class="avatar flex-row">
          <img [src]="imageUrl" [alt]="item.localizedName"/>
        </div>
      </a>
      <div>
        <mat-card-title class="title">
          {{ item.localizedName }}
          <app-copy-text-button [text]="item.localizedName"></app-copy-text-button>
        </mat-card-title>
        <mat-card-subtitle class="subtitle">Tier {{ item.tier }} Enchantment {{ item.enchantmentLevel }}</mat-card-subtitle>
      </div>
    </mat-card-header>
    <mat-divider></mat-divider>
    <mat-card-content class="flex-container card-padding">
      @if (
        ((priceType === PRICE_TYPES.buy || priceType == PRICE_TYPES.sell) && prices && prices.length > 0) ||
        (priceType === PRICE_TYPES.average && histories && histories.length > 0)
      ) {
        @if (showQualityLegend && item.maxQualityLevel === 5) {
          @for (quality of qualities; track quality) {
            <div class="price-chip" [style.background-color]="'#18392b'" [style.margin-bottom]="'10px'">
              {{ quality.name }}
            </div>
          }
        }
        @for (price of prices; track $index; let i = $index) {
          <div
            class="price-chip"
            [style.background-color]="getColorByIndex(price?.city?.index ?? 0)"
            (click)="HandleChipClicked(price)"
          >
            @switch (priceType) {
              <!-- SELECTED BUY PRICE -->
              @case (PRICE_TYPES.buy) {
                <ng-container>
                  {{ getPrice(price) > 0 ? (getPrice(price) | number: '1.0-0') : '-' }}
                  <app-round-badge
                    [visible]="getPrice(price) > 0"
                    [backgroundColor]="getBadgeColor(hoursDifferences[i])"
                    [badgeText]="hoursDifferences[i] | smallNumber"
                    [tooltipText]="(hoursDifferences[i] | number: '1.1-1') + ' hours old'"
                  />
                </ng-container>
              }
              <!-- SELECTED SELL PRICE -->
              @case (PRICE_TYPES.sell) {
                <ng-container>
                  {{ getPrice(price) > 0 ? (getPrice(price) | number: '1.0-0') : '-' }}
                  <app-round-badge
                    [visible]="getPrice(price) > 0"
                    [backgroundColor]="getBadgeColor(hoursDifferences[i])"
                    [badgeText]="hoursDifferences[i] | smallNumber"
                    [tooltipText]="(hoursDifferences[i] | number: '1.1-1') + ' hours old'"
                  />
                </ng-container>
              }
              <!-- SELECTED AVERAGE PRICE -->
              @case (PRICE_TYPES.average) {
                @if (histories) {
                  {{ getPrice(price) > 0 ? (getPrice(price) | number: '1.0-0') : '-' }}
                  <app-round-badge
                    [visible]="
                      (aoDataGetterService.getAveragePriceAndAmount(price.item, price.city, histories, price.qualityLevel, numberOfDaysAverage).averagePrice ??
                        0) > 0
                    "
                    [backgroundColor]="'DimGray'"
                    [badgeText]="
                      aoDataGetterService.getAveragePriceAndAmount(price.item, price.city, histories, price.qualityLevel, numberOfDaysAverage).averageAmount
                        ? (aoDataGetterService.getAveragePriceAndAmount(price.item, price.city, histories, price.qualityLevel, numberOfDaysAverage)
                            .averageAmount! | smallNumber)
                        : '-'
                    "
                    [tooltipText]="
                      aoDataGetterService.getAveragePriceAndAmount(price.item, price.city, histories, price.qualityLevel, numberOfDaysAverage).averageAmount
                        ? (aoDataGetterService.getAveragePriceAndAmount(price.item, price.city, histories, price.qualityLevel, numberOfDaysAverage)
                            .averageAmount! | number: '1.2-2') + ' sold daily'
                        : 'Not enough data for average amount'
                    "
                  />
                }
              }
              <!-- DIDN'T SELECT (IMPOSSIBLE) -->
              @default {
                ERR
              }
            }
          </div>
        }
      } @else {
        <div>No prices avaliable for this item.</div>
      }
    </mat-card-content>
    <mat-card-footer class="flex-container-column">
      @if (footerText) {
        <div>
          <mat-divider></mat-divider>
          <span class="footer-text" [innerHTML]="footerText"></span>
        </div>
      }
      @if (selectedMarketResponse && showChart) {
        <div>
          <mat-divider></mat-divider>
          <app-spark-line-chart
            [chosenPrice]="getPrice(selectedMarketResponse)"
            [histories]="histories"
            [item]="selectedMarketResponse.item"
            [location]="selectedMarketResponse.city"
            [quality]="selectedMarketResponse.qualityLevel"
            [showChart]="true"
            [showButton]="false"
          >
          </app-spark-line-chart>
        </div>
      }
    </mat-card-footer>
  </mat-card>
}

<ng-template #loadingSpinner>
  <div class="spinner-container">
    <mat-spinner [diameter]="40" [strokeWidth]="4"></mat-spinner>
  </div>
</ng-template>
